import { TBaseObj } from '../types/types';

function removeEmptyFields(incomingObj: TBaseObj): TBaseObj {
  const outgoingObj = {};
  Object.keys(incomingObj).forEach((key) => {
    if (
      !incomingObj[key] ||
      (Array.isArray(incomingObj[key]) && !incomingObj[key].length) ||
      (typeof incomingObj[key] === 'object' && !Object.keys(incomingObj[key]).length)
    )
      return;
    outgoingObj[key] = incomingObj[key];
  });
  return outgoingObj;
}

export default removeEmptyFields;
